import { type IUserState } from "./user.interface";

const initialState: IUserState = {
  profile: null,
};

export default initialState;
